import Vue from 'vue'
import store from '@/store/index.js'

import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

import awsconfig from './aws-exports'

awsconfig.API.endpoints.forEach((endpoint => {
    endpoint.custom_header = async () => {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${(await AmplifyModules.Auth.currentSession()).getIdToken().getJwtToken()}`
            // Authorization: `Bearer ${'eyJraWQiOiJ0RWhxUEE4TDhBXC9sZWNGQnVB                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           aRUlcL00xbFlqendIUVpVK3ZhdjFPejZZbWs9IiwiYWxnIjoiUlMyNTYifQ.eyJhdF9oYXNoIjoiRVlQam5yWEstVk9jaVJpeDI1Z1dUdyIsInN1YiI6IjVhMzVmN2QxLTY3NjgtNGU3Mi05ZGMyLTgwNWExNDUwYzMyNCIsImNvZ25pdG86Z3JvdXBzIjpbInVzLXdlc3QtMl9qZnVsMksxUUJfQURGUy5UUy1NRVgiXSwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtd2VzdC0yLmFtYXpvbmF3cy5jb21cL3VzLXdlc3QtMl9qZnVsMksxUUIiLCJjb2duaXRvOnVzZXJuYW1lIjoiYWRmcy50cy1tZXhfdHMtbWV4XFxhODQ1MDExNTEiLCJhdWQiOiIzdmJuNzQycjFhcGVncmV1MGs3MW0zMzM3bCIsImlkZW50aXRpZXMiOlt7InVzZXJJZCI6IlRTLU1FWFxcQTg0NTAxMTUxIiwicHJvdmlkZXJOYW1lIjoiQURGUy5UUy1NRVgiLCJwcm92aWRlclR5cGUiOiJTQU1MIiwiaXNzdWVyIjoiaHR0cDpcL1wvZnMudHMtbWV4LmNvbVwvYWRmc1wvc2VydmljZXNcL3RydXN0IiwicHJpbWFyeSI6InRydWUiLCJkYXRlQ3JlYXRlZCI6IjE1OTM2MTc1NjA4NjQifV0sInRva2VuX3VzZSI6ImlkIiwiYXV0aF90aW1lIjoxNTk1NjAxNjMyLCJuYW1lIjoiUmFtb3MgR29uemFsZXogT21hciBFbnJpcXVlIiwiZXhwIjoxNTk2MDcyMTQwLCJpYXQiOjE1OTYwNjg1NDAsImVtYWlsIjoib21hci1lbnJpcXVlLnJhbW9zQHQtc3lzdGVtcy5jb20ifQ.PGlNuwWQL7mmmgyqZR1pKlb8qy4pFfq2FnSSElfzUkF23mq-ownSfAcWEdy2r6dhQFWjHt97SquWeLIwpkFZv6L1p788r2wyGHx1A-wBuZVquFQhWfgimBi5-ecaas1ihL0JhEZ5RHj83VC5XHb_MYr0mw8cCPIeYeOBNXUAAQ0Zf3f4zq_mOztYSXQr4yzhJqOEm4nIldsz6z31N0BBP8lwWqMr_IrfZNQeuKP7cf9MqiS1UEHlGe6FkFBK25Mn371A8OUgwV_eqHLYTRkZFBthRtpwvXD2UKFoJRraXXKH7q2bqEeZmR8yfgbkdKaqjqA2YD_kNz4zjy9faqL7lw'}`
        }
    }
}))

Amplify.configure(awsconfig)

AmplifyModules.API.configure(awsconfig);

let API_NAME = "qa-AppTSMXServerless";

//
Vue.prototype.$GETQA         = async (url, params) => {
    store.dispatch("initLoader");
    if (params) {
        Object.keys(params).forEach(key => {
            let pattern = RegExp(`{{${key}}}`, "g")
            url = url.replace(pattern, params[key])
        })
    }
    return AmplifyModules.API.get(API_NAME, url ) //, HEADERS())
        .then(response => {
            return response;
        })
        .finally(() => store.dispatch("stopLoader"));
};

Vue.prototype.$POSTQA = async (url, payload) => {
    store.dispatch("initLoader");
    if (payload && payload.params) {
        Object.keys(payload.params).forEach(key => {
            let pattern = RegExp(`{{${key}}}`, "g")
            url = url.replace(pattern, payload.params[key])
        })
    }

    let data = payload && payload.data ? payload.data : {}
    return AmplifyModules.API.post(API_NAME, url, {
        // headers: HEADERS(),
        body: data
    })
        .then(response => {
            return response;
        })
        .finally(() => store.dispatch("stopLoader"));
};

Vue.prototype.$PUTQA = async (url, payload) => {
    store.dispatch("initLoader");
    if (payload && payload.params) {
        Object.keys(payload.params).forEach(key => {
            let pattern = RegExp(`{{${key}}}`, "g")
            url = url.replace(pattern, payload.params[key])
        })
    }

    let data = payload && payload.data ? payload.data : {}
    return AmplifyModules.API.put(API_NAME, url, {
        // headers: HEADERS(),
        body: data
    })
        .then(response => {
            return response;
        })
        .finally(() => store.dispatch("stopLoader"));
};

Vue.prototype.$DELETEQA = async (url, payload) => {
    store.dispatch("initLoader");
    if (payload && payload.params) {
        Object.keys(payload.params).forEach(key => {
            let pattern = RegExp(`{{${key}}}`, "g")
            url = url.replace(pattern, payload.params[key])
        })
    }

    let data = payload && payload.data ? payload.data : {}
    return AmplifyModules.API.del(API_NAME, url, {
        // headers: HEADERS(),
        body: data
    })
        .then(response => {
            return response;
        })
        .finally(() => store.dispatch("stopLoader"));
};

Vue.use(AmplifyPlugin, AmplifyModules);

export default {}